// extracted by mini-css-extract-plugin
module.exports = {"pill":"PricingNavLabel_pill__SQ3W5","inline":"PricingNavLabel_inline__atpCF","below":"PricingNavLabel_below__ioKYr","pop":"PricingNavLabel_pop__RPxph"};